import { Component, Input, OnInit } from '@angular/core'

@Component({
  selector: 'no-data-page',
  templateUrl: './no-data-page.component.html',
  styleUrls: ['./no-data-page.component.scss'],
})
export class NoDataPageComponent implements OnInit {
  @Input() noDataCaas: any
  noDatacaasContent: any
  ngOnInit() {
    if (this.noDataCaas) {
      this.noDatacaasContent = this.sanitize(
        this.noDataCaas.pageNotAvailable.html,
      )
    }
  }
  sanitize(data: any) {
    return data
      .replaceAll('&lt;', '<')
      .replaceAll('&gt;', '>')
      .replaceAll('&quot;', '"')
      .replaceAll('&nbsp;', '')
      .replaceAll('<br>', '')
  }
}
